<div class="size clearfix mb-4 pointer d-flex align-items-center"
     (click)="onSelect.emit(size)"
     [class.active]="active">
  <ng-container
    *ngIf="size.details.shape !== 'TWO-LEVEL-ROUND' && size.details.shape !== 'THR-LEVEL-ROUND' && size.details.shape !== 'FOR-LEVEL-ROUND'">
    <span class="size-shape {{size.details.shape}}"></span>
  </ng-container>
  <ng-container
    *ngIf="size.details.shape == 'TWO-LEVEL-ROUND' || size.details.shape == 'THR-LEVEL-ROUND' || size.details.shape == 'FOR-LEVEL-ROUND'">
          <span class="shape-container">
            <span class="size-shape size-shape-level "></span>
            <span class="size-shape size-shape-level  TWO-LEVEL-ROUND"></span>
            <span *ngIf="size.details.shape === 'THR-LEVEL-ROUND' || size.details.shape === 'FOR-LEVEL-ROUND'"
                  class="size-shape size-shape-level  THR-LEVEL-ROUND"></span>
            <span *ngIf="size.details.shape === 'FOR-LEVEL-ROUND'"
                  class="size-shape size-shape-level FOR-LEVEL-ROUND"></span>
          </span>
  </ng-container>
  <div class="size-info">
    <div class="fw-bold">
      {{size.details.value}}
      <span class="measurement">{{size.details.measurement}} - </span>
      <span class="price">
        {{size.minPrice | tryToDiscountPrice: discount: currency}}
      </span>
    </div>
    <div class="size-definition font-sm">
      {{size.details.definition}}
    </div>
  </div>
</div>
